import React, {Component} from 'react'
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AlertConfirm from "../modals/Confirm";
import CountrySelect from "react-bootstrap-country-select";
import Error from "../single_components/Error";
import SvGraphics from "../../assets/SvGraphics";
import doctorApi from "../../services/ApiServices/doctorApi";
import patientApi from "../../services/ApiServices/patientApi";

class SelfPatientDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
            toOpenFemaleQues: false,
            isUnder50:false,
            countryNotIsrael: false,
            recommendationLetter:false,
            drive:false,
            work:false,
            learn:false,
            smoke:false,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }
    componentDidMount() {
        this.setState({toOpenFemaleQues: this.state.entry.Gender==="Female",countryNotIsrael: !(this.state.entry.BornInIsrael !=="No")
        ,pregnant: this.state.entry.Pregnant==="Yes",breast_feeding: this.state.entry.Breast_feeding==="Yes",})
    }

    onImageChange = async (event) => {
        let {entry}=this.state
        if (event.target.files && event.target.files[0]) {
            let fileToAdd={
                file: event.target.files[0],
                UserStorageID: entry.UserStorageID
            }

            let response = await patientApi.uploadProfilePng(fileToAdd)
            if(response){
                let imgUrl = response.data[0].Form_url
                this.props.onclickSetProfilePic(imgUrl)
            }
        }
    };
    onImageDelete = async () => {
        let {entry}=this.state

        let response = await patientApi.deleteUploadedFiles(entry.UserStorageID, {Form_id:0})
        if (response){
            this.props.onclickSetProfilePic("")
        }
    };

    checkPatientAge(){
        let {entry}=this.state
        if(entry.Date_of_birth!==null){
            let todayDate= new Date().toISOString()
            let todayExactDate=(todayDate.split('T'))[0].split('-')
            let currentYear =todayExactDate[0]
            let currentMonth =todayExactDate[1]
            let currentDay =todayExactDate[2]
            let birthDate=entry.Date_of_birth?entry.Date_of_birth.toISOString():""
            let exactDate=(birthDate.split('T'))[0].split('-')
            let yearDiff =currentYear - exactDate[0]
            let monthDiff =currentMonth-exactDate[1]
            let dayDiff =currentDay-exactDate[2]-1
            if((yearDiff<50)|| (yearDiff===50 && (monthDiff<0 ||(monthDiff===0 && dayDiff<0)))){
                this.setState({isUnder50:true})
            }else{
                entry['Breast_feeding']=""
                entry['Pregnant']=""
                entry['Gynecologist_letter']=""
                this.setState({isUnder50:false,entry})            }
        }
    }
    onGenderChoose(event){
        let {entry} = this.state
        if(event.target.value !== "Female"){
            entry['Breast_feeding']=""
            entry['Pregnant']=""
            entry['Gynecologist_letter']=""
        }
        this.setState({toOpenFemaleQues: event.target.value === "Female",entry})
        this.props.onValueChange("Gender", event.target.value)
    }
    onclickCountry(value){
        if(value === "No"){
            this.props.onValueChange("Birth_country", "")
            this.setState({countryNotIsrael: value === "No"})
        }else{
            this.props.onValueChange("Birth_country", "Israel")
            this.setState({countryNotIsrael: value === "No"})
        }
        this.props.onYesNoValueChange("BornInIsrael", value)
    }

    onclickPregnantBreastFeeding(code,value){
        let {entry}=this.state
        this.props.onYesNoValueChange(code, value)
        if(entry.Pregnant !=="Yes" && entry.Breast_feeding !=="Yes"){
            this.props.onValueChange("Gynecologist_letter", "")

        }
    }


    async onclickFemaleDoc(value) {
        this.props.onYesNoValueChange("Gynecologist_letter", value)
        let {t} = this.props
        let message = t('patient_self_boarding.Consider_Continue_boarding')
        if (value === "No") {
            let confirm = await AlertConfirm({
                options: {
                    title: ``,
                }
            }, message)
                  /*  if (!confirm) {
                        this.props.goBack()
                    }*/
        }
    }

    countryChange(value){
        if(value){
            this.props.onValueChange("Birth_country", value.id)
        }else{
            this.props.onValueChange("Birth_country", "")

        }
    }
    onBirthdayChange=(event)=>{
        this.props.onValueChange("Date_of_birth", event)
        this.checkPatientAge()
    }
    render() {
        let {entry,isUnder50}= this.state
        let {t} = this.props

        let maxBirthday=new Date()
        maxBirthday.setFullYear(maxBirthday.getFullYear()-10)

        let minBirthday=new Date()
        minBirthday.setFullYear(1921)

        let kidsArr = []
        for(let i =0;i<=15;i++){
            kidsArr.push(<option value={i}>{i}</option>)
        }

        return (
            <div className={'patientsFormBoxes'}>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <div style={{display:"flex"}}>
                            <label className={'infoLabel'} >{t('patient_self_boarding.id_number')}*</label>
                            <Error isShown={!!(this.props.errors)['ID_passport']} errorMessage={(this.props.errors)['ID_passport']}/>
                        </div>
                        <input className={'inputBoxStyle'} type="text"  name="ID" defaultValue={entry.ID_passport}
                               maxLength={9}
                               onChange={(event) => this.props.onValueChange("ID_passport", event.target.value)}/>

                    </div>
                    <div className={'inputSlots'}>
                        <div style={{display:"flex"}}>
                            <label className={'infoLabel'} >{t('patient_self_boarding.first_name')}*</label>
                            <Error isShown={!!(this.props.errors)['First_name']} errorMessage={(this.props.errors)['First_name']}/>
                        </div>
                        <input className={'inputBoxStyle'} type="text"  name="First_name" defaultValue={entry.First_name}
                               maxLength={20}
                               onChange={(event) => this.props.onValueChange("First_name", event.target.value)}/>
                    </div>
                    <div className={'inputSlots'}>
                        <div style={{display:"flex"}}>
                            <label className={'infoLabel'} >{t('patient_self_boarding.last_name')}*</label>
                            <Error isShown={!!(this.props.errors)['Last_name']} errorMessage={(this.props.errors)['Last_name']}/>
                        </div>
                        <input className={'inputBoxStyle'} type="text"  name="Last_name" defaultValue={entry.Last_name}
                               maxLength={20}
                               onChange={(event) => this.props.onValueChange("Last_name", event.target.value)}/>
                    </div>
                    <div className={'inputSlots'}>
                        <div style={{display:"flex"}}>
                            <label className={'infoLabel'} >{t('patient_self_boarding.sex')}*</label>
                            <Error isShown={!!(this.props.errors)['Gender']} errorMessage={(this.props.errors)['Gender']}/>
                        </div>
                        <select className={'selectBox'} id="Gender" name="Gender" value={entry.Gender} onChange={this.onGenderChoose.bind(this)}>
                            <option/>
                            <option value="Male">{t('patient_self_boarding.male')}</option>
                            <option value="Female">{t('patient_self_boarding.female')}</option>
                            <option value="Specified">{t('patient_self_boarding.not_specified')}</option>
                        </select>
                    </div>
                </div>


                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <div style={{display:"flex"}}>
                            <label className={'infoLabel'}>{t('patient_self_boarding.Date_of_birth')}*</label>
                            <Error isShown={!!(this.props.errors)['Date_of_birth']} errorMessage={(this.props.errors)['Date_of_birth']}/>
                        </div>
                        <DatePicker
                            className={'inputBoxStyle-medium'}
                            showYearDropdown={true} showMonthDropdown={true}
                            dateFormat="dd/MM/yyyy"
                            selected={entry.Date_of_birth}
                            maxDate={maxBirthday}
                            minDate={minBirthday}
                            onChange={(event) => this.onBirthdayChange(event)}/>

                    </div>

                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.Marital_status')}</label>
                        <select className={'selectBox'} id="family" name="FamilyStatus" value={entry.Marital_status}
                                onChange={(event) => this.props.onValueChange("Marital_status", event.target.value)}>
                            <option/>
                            <option value="Single">{t('patient_self_boarding.Single')}</option>
                            <option value="common-law-marriage">{t('patient_self_boarding.common-law-marriage')}</option>
                            <option value="Married">{t('patient_self_boarding.married')}</option>
                            <option value="Separeted">{t('patient_self_boarding.separeted')}</option>
                            <option value="Divorced">{t('patient_self_boarding.divorced')}</option>
                            <option value="Widowed">{t('patient_self_boarding.widowed')}</option>
                            <option value="Other">{t('patient_self_boarding.other')}</option>
                        </select>
                    </div>

                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.kids_num')}</label>
                        <select className={'selectBox'} value={entry.kids_num}
                                onChange={(event) => this.props.onValueChange("kids_num", event.target.value)}>
                            <option/>
                            {kidsArr}
                        </select>
                    </div>

                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.Education')} </label>
                        <select className={'selectBox'} id="Education" name="Education" value={entry.Education}
                                onChange={(event) => this.props.onValueChange("Education", event.target.value)}>
                            <option/>
                            <option value="Elementary">{t('patient_self_boarding.Elementary')}</option>
                            <option value="HighSchool">{t('patient_self_boarding.HighSchool')}</option>
                            <option value="Academic">{t('patient_self_boarding.Academic')}</option>
                            <option value="Other">{t('patient_self_boarding.other')}</option>
                        </select>
                    </div>

                </div>

                <div className={'patientsFormRow'} style={{ display: (entry.Gender==="Female" && isUnder50)?'flex': 'none' }}>

                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_self_boarding.pregnant')}?*</label>
                            <Error isShown={!!(this.props.errors)['Pregnant']} errorMessage={(this.props.errors)['Pregnant']}/>
                        </div>
                        <button tabIndex={0}  className={entry.Pregnant==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.onclickPregnantBreastFeeding("Pregnant", "Yes")}>{t('patient_self_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Pregnant==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.onclickPregnantBreastFeeding("Pregnant", "No")}>{t('patient_self_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>

                </div>

                <div className={'patientsFormRow'} style={{ display: entry.Gender==="Female" && isUnder50?'flex': 'none' }}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_self_boarding.Breast_feeding')}?*</label>
                            <Error isShown={!!(this.props.errors)['Breast_feeding']} errorMessage={(this.props.errors)['Breast_feeding']}/>
                        </div>
                        <button tabIndex={0}  className={entry.Breast_feeding==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.onclickPregnantBreastFeeding("Breast_feeding", "Yes")}>{t('patient_self_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Breast_feeding==="No"?'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.onclickPregnantBreastFeeding("Breast_feeding", "No")}>{t('patient_self_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>

                </div>

                <div className={'patientsFormRow'} style={{ display:entry.Pregnant==="Yes" ||entry.Breast_feeding==="Yes" ?'block': 'none' }}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_self_boarding.gynecologist_document')}?</label>
                        </div>
                        <button tabIndex={0}  className={entry.Gynecologist_letter==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.onclickFemaleDoc("Yes")}>{t('patient_self_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Gynecologist_letter==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.onclickFemaleDoc("No")}>{t('patient_self_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>

                </div>

                <div className={'patientsFormRow2'}>
                    <div className={'inputSlots'}>
                        <div style={{display:"flex"}}>
                            <label className={'infoLabel'}>{t('patient_self_boarding.Insurance')}*</label>
                            <Error isShown={!!(this.props.errors)['Insuring_factor']} errorMessage={(this.props.errors)['Insuring_factor']}/>
                        </div>
                        <select className={'selectBox'} id="InsuranceType" name="InsuranceType" value={entry.Insuring_factor}
                                onChange={(event) => this.props.onValueChange("Insuring_factor", event.target.value)}>
                            <option/>
                            <option value={"1"}>{t('patient_self_boarding.Maccabi')}</option>
                            <option value={"2"}>{t('patient_self_boarding.Clalit')}</option>
                            <option value={"3"}>{t('patient_self_boarding.Leumit')}</option>
                            <option value={"4"}>{t('patient_self_boarding.Meuhedet')}</option>
                            <option value={"5"}>{t('patient_self_boarding.InsuranceCompany')}</option>
                            <option value={"6"}>{t('patient_self_boarding.IDF')}</option>
                            <option value={"7"}>{t('patient_self_boarding.MinistryOfDefence')}</option>
                            <option value={"8"}>{t('patient_self_boarding.None')}</option>
                            <option value={"9"}>{t('patient_self_boarding.PalestinianAuthority')}</option>
                            <option value={"10"}>{t('patient_self_boarding.other')}</option>
                        </select>
                    </div>
                </div>

                <div className={'patientsFormRow'}>
                    <div style={{display:'block'}}>
                        <img className={'profilePic'} style={{display:this.props.profilePic?'block':'none'}} src={this.props.profilePic} width={'100px'} height={'100px'}/>
                        <SvGraphics className={"delete-icon-profilepic"} style={{display:this.props.profilePic?'block':'none'}}
                                    onClick={() => this.onImageDelete()} svgname={'delete-icon'}/>
                    </div>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'} >{t('patient_self_boarding.picture')}</label>
                        <input className={'inputBoxStyle-photo'} type="file" name="myImage" onChange={this.onImageChange} />
                    </div>

                </div>
    {/*            <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_self_boarding.receiving_asaya_system_assisted')}?*</label>
                            <Error isShown={!!(this.props.errors)['receiving_asaya_system_assisted']} errorMessage={(this.props.errors)['receiving_asaya_system_assisted']}/>
                        </div>
                        <button tabIndex={0} className={entry.receiving_asaya_system_assisted==="Yes"? 'inputBoxStyle-yes-no-selected' :'inputBoxStyle-yes-no'}
                                onClick={(event) => this.props.onYesNoValueChange("receiving_asaya_system_assisted","Yes")}>{t('patient_self_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.receiving_asaya_system_assisted==="No"? 'inputBoxStyle-yes-no-selected' :'inputBoxStyle-yes-no'}
                                onClick={(event) => this.props.onYesNoValueChange("receiving_asaya_system_assisted","No")}>{t('patient_self_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                </div>*/}


            </div>

        )
    }
}

SelfPatientDetails.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default SelfPatientDetails;
